var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen flex flex-col"},[(!_vm.hideNavBar)?_c('navbar'):_vm._e(),_c('router-view',{on:{"hideNavBar":_vm.setHideNavBar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }